module.exports = __webpack_public_path__ + "static/img/backgroundImage.190b7d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/productCenter/backgroundImage.png
// module id = xdaV
// module chunks = 7